import { ApiResponse } from "@/utils/ApiResponse";
import { gpedPedidoInterface } from "../interfaces/gpedPedido.inteface";
import apiClient from "@/clients/apiClient";
import { gpedPedidosPaginacionFilterParams } from "../interfaces/gpedPedidosPaginacionFilterParams";

function queryParamsFrom(
  p: gpedPedidosPaginacionFilterParams
): Record<string, string | number | undefined> {
  const out: Record<string, string | number | undefined> = {
    page: p.page,
    limit: p.limit,
    search: p.search?.trim() || undefined,
    sortBy: p.sortBy,
    sortOrder: p.sortOrder,
  };
  const en = p.estadoNombre?.trim();
  if (en) out.estadoNombre = en;
  return out;
}

export async function ListPedidosAction(
  paramsPedido: gpedPedidosPaginacionFilterParams
): Promise<ApiResponse<gpedPedidoInterface>> {
  const { data } = await apiClient.get<gpedPedidoInterface>(
    "/gpedPedido",
    {
      params: queryParamsFrom(paramsPedido),
    }
  );
  return {
    status: 200,
    data,
    message: "Pedidos obtenidos correctamente",
  };
}
